import Link from 'next/link'
import React, { ComponentProps } from 'react'

import { faCircleChevronRight } from '@fortawesome/pro-light-svg-icons/faCircleChevronRight'
import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

import { Button } from '../Button/Button'
import { Icon } from '../Icon/Icon'
import { StyledLinkButton } from './styledMenuLinks'

export type MegaMenuMuiLinkProps = ComponentProps<typeof Button> & {
  href: string;
}

const StyledGridLink = styled(Grid)`
  padding: ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(20)}
    ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(20)};

  ${(props) => props.theme.breakpoints.up('sm')} {
    padding-left: ${(props) => props.theme.typography.pxToRem(16)};
    padding-right: ${(props) => props.theme.typography.pxToRem(16)};
  }
  
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding-left: ${(props) => props.theme.typography.pxToRem(24)};
  }
`

export const MegaMenuMuiLink: React.FC<MegaMenuMuiLinkProps> = ({ children, href }) => (
  <StyledGridLink container justifyContent="space-between" alignItems="center">
    <Grid item>
      <Link href={href}>
        <StyledLinkButton
          disableRipple
          endIcon={
            <Icon icon={faCircleChevronRight} sx={{ width: '18px' }} width={18} height={18} />
          }
        >
          {children}
        </StyledLinkButton>
      </Link>
    </Grid>
  </StyledGridLink>
)
